import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/router";
import { useForm } from "react-hook-form";

import ShelfEditor from "../../components/shelf/shelfEditor.comp";
import Layout from "../../components/layouts/layout.comp";
import { post } from "../../core/fetch.core";
import { useTranslation } from "../../core/translation.core";
import { ShelfFormData } from "../../types/shelf";

export default function CreateShelfPage() {
  const { t, msg } = useTranslation();
  const methods = useForm<ShelfFormData>();
  const { push } = useRouter();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async (data: ShelfFormData) => {
      await post("/admin/shelf/create", data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["shelves"] });
      push("/shelves");
    },
  });

  return (
    <Layout title={t(msg.shelf.add)}>
      <ShelfEditor methods={methods} mutation={mutation} btnName={t(msg.form.create)} />
    </Layout>
  );
}
